export default {"src":"/_next/static/media/HalfStarIcon.e91d0817.svg","height":15,"width":15};